import { ChangeEvent, useEffect, useState } from "react";
import { IUser } from "../../type";
import "./index.css";

interface IProps {
  user: IUser;
  onClickRight: (n: string) => void;
  onClickLeft: () => void;
}

export function EmailEdit(props: IProps) {
  const [value, setValue] = useState<string>("");
  const [error, setError] = useState<string>("");

  useEffect(() => {
    setValue(props.user.email || "");
  }, [props.user]);

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    setValue(e.target.value);
    setError("");
  }

  const onclkbtn = () => {
    if (value.trim() === "") {
      setError("Пожалуйста, введите ваш e-mail.");
    } else {
      props.onClickRight(value);
    }
  };

  return (
    <section className="section mainPage flex flex-column sectionUser profileEditStep">
      <input
        className="editDataProfile withPadd"
        type="email"
        id="email"
        name="name"
        value={value}
        onChange={handleChange}
        placeholder="E-mail"
        autoFocus
        required
        minLength={6}
        maxLength={80}
        onKeyUp={(e) => {
          if (e.code === "Enter") {
            onclkbtn();
          }
        }}
      />
      {error && <p className="error-message">{error}</p>}

      <div className="conteinerbtn">
        <div
          className="mainContentSurveyLesson-skipButton "
          onClick={() => {
            props.onClickLeft();
          }}
        >
          Назад
        </div>
        <div className="mainContentSurveyLesson-sendButton" onClick={onclkbtn}>
          Далее
        </div>
      </div>
    </section>
  );
}
